export default "__VITE_ASSET__BgVEzQue__"